import { InstanceScreen } from 'component/navigation/instance';

export default function ArticleAdminLinksScreen() {
    return <InstanceScreen screenKey='adminLinks' />;
}
